import type { UserService } from './user.service';
import { TranslocoService } from '@jsverse/transloco';
import { inject } from '@angular/core';

export function userAppInitializerFactory(userService: UserService): () => Promise<unknown> {
  const translocoService = inject(TranslocoService);

  return () =>
    userService.initApp().then(({ profile: { lcid } }) => {
      if (lcid.length === 0) {
        lcid = 'hu';
      }
      translocoService.setActiveLang(lcid);
      return true;
    });
}
